import { WhitelabelConstants } from '../constants';
import { WhitelabelService } from '../../services/';
import { whitelabelObj } from '../../config'

export const WhitelabelActions = {
	fetchWhitelabel,
	setWhitelabel,
	
};

function fetchWhitelabel() {
	return (dispatch) => {
		dispatch(request());

		WhitelabelService.fetchWhitelabel().then(
			(whitelabel) => {
				dispatch(success(whitelabel));
			},
			(error) => dispatch(failure(error.toString()))
		);
	};
}

function setWhitelabel() {
	return (dispatch) => {
		dispatch(success(whitelabelObj));
	};
}

function request() {
	return { type: WhitelabelConstants.GETWHITELABEL_REQUEST };
}

function success(whitelabel) {
	if (whitelabel.length > 0) {
		const api_app_version = whitelabel[0].app_version;
		const storage_app_version = localStorage.getItem('app_version');

		localStorage.setItem('project_id', whitelabel[0].id);

		if (storage_app_version !== null) {
			if (api_app_version > storage_app_version) {
				if (window.localStorage) {
					if (!localStorage.getItem('firstLoad')) {
						localStorage['firstLoad'] = true;
						window.location.reload(true);
					} else localStorage.removeItem('firstLoad');
				}
				localStorage.setItem('app_version', api_app_version);
			}
		} else {
			localStorage.setItem('app_version', api_app_version);
		}
		return { type: WhitelabelConstants.GETWHITELABEL_SUCCESS, whitelabel };
	} else {
		const whitelabel = whitelabelObj;
		return { type: WhitelabelConstants.GETWHITELABEL_SUCCESS, whitelabel };
	}
}

function failure(error) {
	return { type: WhitelabelConstants.GETWHITELABEL_FAILURE, error };
}



// WEBPACK FOOTER //
// ./src/store/actions/whitelabel.actions.js